import environment from 'environment';

class TimeoutService {
  constructor($state, $window, SessionService, SecurityApiService) {
    'ngInject';

    this.$state = $state;
    this.$window = $window;

    this.SessionService = SessionService;
    this.SecurityApiService = SecurityApiService;
  }

  initialize() {
    this.idleSeconds = 0;
    this.sessionSeconds = 0;

    this.$window.addEventListener('click', (e) => {
      this.idleSeconds = 0;
    });

    this.$window.addEventListener('mouseover', (e) => {
      this.idleSeconds = 0;
    });

    this.$window.addEventListener('keypress', (e) => {
      this.idleSeconds = 0;
    });

    this.SessionService.session.subscribe((session) => {
      if (session) {
        this.startTimer();
      } else {
        this.stopTimer();
      }
    });
  }

  startTimer() {
    this.interval = this.$window.setInterval(() => {
      this.sessionSeconds++;
      this.idleSeconds++;

      if (this.idleSeconds === environment.IDLE_TIMEOUT) {
        this.$state.go('log-out', {reason: 'inactive'});
      }

      if (this.sessionSeconds === 10) {
        if (this.checkSessionIsExpired() === true) {
          this.$state.go('log-out', {reason: 'session_expired'});
        }
        this.sessionSeconds = 0;
      }
    }, 1000);
  }

  checkSessionIsExpired() {
    this.SecurityApiService.checkSessionExpiration().then((resp) => {
      return resp.session_expired;
    });
  }

  stopTimer() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}

export default TimeoutService;



// WEBPACK FOOTER //
// ./client/app/shared/security/timeout.service.js